import { render, staticRenderFns } from "./IntroOperasi.vue?vue&type=template&id=6ca1cc98&"
import script from "./IntroOperasi.vue?vue&type=script&lang=js&"
export * from "./IntroOperasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports